import type { components } from '@copilot/shared-types';
import { httpClient } from '../../shared/http/client';

export type SearchEnvelope = components['schemas']['SearchEnvelope'];
export type SearchHit = components['schemas']['SearchHit'];

export interface SearchParams {
  q: string;
  from?: string | null;
  to?: string | null;
  user_id?: string | null;
  cursor?: string | null;
  limit?: number;
}

export async function searchTranscripts(params: SearchParams): Promise<SearchEnvelope> {
  const response = await httpClient.get<SearchEnvelope>('/api/v1/meetings/search', {
    params: {
      q: params.q,
      from: params.from ?? undefined,
      to: params.to ?? undefined,
      user_id: params.user_id ?? undefined,
      cursor: params.cursor ?? undefined,
      limit: params.limit ?? 20,
    },
  });
  return response.data;
}
